import React, { useEffect, useRef, useState } from "react"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { Row, Col, Card, CardBody, Table } from "reactstrap"
import Paginations from "components/Common/Paginations"
import { useLocation, useNavigate } from "react-router-dom"
import Filters from "components/Common/Filters"
import { useDispatch } from "react-redux"
import { useSelector } from "react-redux"
import { getCustomerLoyaltyPoints } from "store/actions/customersAction"
import TableShimmer from "components/Shared/TableShimmer"
import formatDateTime from "components/Shared/formatDateTime"
import DataExportDropdown from "components/Shared/DataExportDropdown"
import { pdfDownload, post } from "helpers/api_helper"
import { EXPORT_DATA } from "helpers/url_helper"
import DownloadCSV from "components/Shared/DownloadCSV"
import DownloadXLSX from "components/Shared/DownloadXLSX"
import isPermissionEnabled, {
  getSubPermissions,
} from "common/isPermissionEnabled"
import { useTranslation } from "react-i18next"
import { showAlert } from "store/reducers/alertReducer"
import { getPerPageOptions, todayDate } from "components/Common/constants"
import { setItemsPerPage } from "store/reducers/customersReducer"

const CustomerLoyalty = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation()

  document.title = t("Loyalty | Namq")
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const page = parseInt(searchParams.get("page")) || 1
  const [searchTerm, setSearchTerm] = useState("")
  const [searchTerm2, setSearchTerm2] = useState("")

  const { userRole, accountType, authUser } = useSelector(state => state.Login)

  const [usersPermissions, setUsersPermissions] = useState({
    list: null,
    edit: null,
  })

  // FIRST CHECK PERMISSION, IF DOES'T HAVE THEN REDIRECT TO DASHBOARD
  useEffect(() => {
    const isPermissionList = isPermissionEnabled(
      userRole,
      7,
      "customersPermission_1",
      accountType
    )

    const customerSubPermissions = getSubPermissions(
      userRole,
      7,
      "customersPermission_1",
      accountType
    )

    const isPermissionEdit = isPermissionEnabled(
      userRole,
      7,
      "customersPermission_2",
      accountType
    )

    if (
      !isPermissionList ||
      !customerSubPermissions?.view_loyalty_points?.isEnabled
    ) {
      navigate("/dashboard")
    }
    setUsersPermissions({
      list: isPermissionList,
      edit: isPermissionEdit,
    })
  }, [userRole])

  const {
    loyaltyLoading,
    isLoading,
    isUpdating,
    totalCount,
    itemsPerPage,
    totalPages,
    currentPage,
    customerLoyaltyPoints,
  } = useSelector(state => state.Customers)

  const flatpickrRef = useRef(null)

  const [dateRange, setDateRange] = useState({
    min: todayDate,
    max: todayDate,
  })

  const [selectedFilters, setSelectedFilters] = useState({
    sortOrder: 2,
    pointType: "",
  })
  const [isApiCalled, setIsApiCalled] = useState(false)

  useEffect(() => {
    fetchCustomerLoyaltyPoints()
  }, [])

  const fetchCustomerLoyaltyPoints = () => {
    const payload = {
      perPage: itemsPerPage,
      pageNo: page,
      orderBy: 2,
      keyword: "",
      userId: "",
      pointType: "", // collect, redeem
      dateRange:
        dateRange.min && dateRange.max
          ? { min: dateRange.min, max: dateRange.max }
          : {},
      orderNo: "",
    }
    dispatch(getCustomerLoyaltyPoints(payload))
    setIsApiCalled(true)
  }

  const filters = [
    {
      name: "sortOrder",
      type: "select",
      options: [
        { label: t("Ascending"), value: 1 },
        { label: t("Descending"), value: 2 },
      ],
      placeholder: t("Ascending"),
    },
    {
      name: "pointType",
      type: "select",
      options: [
        { label: t("All"), value: "" },
        { label: t("Collect"), value: "collect" },
        { label: t("Redeem"), value: "redeem" },
      ],
      placeholder: t("Point Type"),
    },
  ]

  const handleSearchChange = e => {
    setSearchTerm(e.target.value)
  }

  const handleSearchChange2 = e => {
    setSearchTerm2(e.target.value)
  }

  const handleFetchLoyaltyPoints = (page = 1) => {
    const { sortOrder, pointType } = selectedFilters

    const payload = {
      perPage: itemsPerPage,
      pageNo: page,
      orderBy: Number(sortOrder),
      keyword: searchTerm || "",
      orderNo: searchTerm2 || "",
      userId: "",
      pointType,
      dateRange:
        dateRange.min && dateRange.max
          ? { min: dateRange.min, max: dateRange.max }
          : {},
    }

    dispatch(getCustomerLoyaltyPoints(payload))
      .then(action => {
        const { statusCode, status } = action?.payload
        if (statusCode === 200 && status) {
          navigate(`/customers/loyalty?page=${page}`)
        }
      })
      .catch(error => {
        // Handle error if needed
      })
  }

  const handleSearch = () => {
    handleFetchLoyaltyPoints(1) // Always start from page 1 for a search
  }

  const onPageChange = page => {
    handleFetchLoyaltyPoints(page)
  }

  // useEffect(() => {
  //   if (isApiCalled) {
  //     if (searchTerm || searchTerm2) {
  //       const delayDebounceFn = setTimeout(() => {
  //         handleSearch()
  //       }, 500)

  //       return () => clearTimeout(delayDebounceFn)
  //     } else {
  //       handleSearch()
  //     }
  //   }
  // }, [searchTerm, searchTerm2, selectedFilters, itemsPerPage])

  // useEffect(() => {
  //   if (dateRange.min && dateRange.max) {
  //     handleSearch()
  //   }
  // }, [dateRange])

  const handleFilterChange = (selectedValue, filterName) => {
    setSelectedFilters(prevFilters => ({
      ...prevFilters,
      [filterName]: selectedValue,
    }))
  }

  const handleReset = () => {
    dispatch(setItemsPerPage(10))
    setSelectedFilters({
      sortOrder: 2,
      pointType: "",
    })

    setSearchTerm("")
    setSearchTerm2("")
    setDateRange({ min: todayDate, max: todayDate })
    if (flatpickrRef.current) {
      flatpickrRef.current.flatpickr.setDate([todayDate, todayDate])
    }
    const payload = {
      perPage: 10,
      pageNo: 1,
      orderBy: 2,
      keyword: "",
      orderNo: "",
      userId: "",
      pointType: "",
      dateRange: { min: todayDate, max: todayDate },
    }
    dispatch(getCustomerLoyaltyPoints(payload))
    // if (flatpickrRef.current) {
    //   flatpickrRef.current.flatpickr.clear()
    // }
    navigate("/customers/loyalty?page=1")
  }

  const exportToCSV = async () => {
    const { pointType } = selectedFilters

    const payload = {
      // status: 1,
      keyword: searchTerm || "",
      type: "LOYALTY-POINTS",
      exportType: "csv",
      userId: "",
      pointType,
      dateRange:
        dateRange.min && dateRange.max
          ? { min: dateRange.min, max: dateRange.max }
          : {},
    }
    const response = await post(EXPORT_DATA, payload)
    if (response) {
      // const csvData = response
      // DownloadCSV(csvData, t("Loyalty Points"))
      const { statusCode, status, msg } = response
      if (statusCode === 200 && status) {
        dispatch(showAlert({ text: msg, type: "success" }))
      } else {
        dispatch(showAlert({ text: msg, type: "error" }))
      }
    }
  }

  const handleExcelDownload = async () => {
    const { pointType } = selectedFilters

    const payload = {
      // status: 0,
      keyword: searchTerm || "",
      type: "LOYALTY-POINTS",
      exportType: "xlsx",
      pointType,
      userId: "",
      dateRange:
        dateRange.min && dateRange.max
          ? { min: dateRange.min, max: dateRange.max }
          : {},
    }
    const response = await post(EXPORT_DATA, payload)
    if (response) {
      // const xlsxData = response
      // DownloadXLSX(xlsxData, t("Loyalty Points"))
      const { statusCode, status, msg } = response
      if (statusCode === 200 && status) {
        dispatch(showAlert({ text: msg, type: "success" }))
      } else {
        dispatch(showAlert({ text: msg, type: "error" }))
      }
    }
  }

  const perPageOptions = getPerPageOptions(totalCount)

  const handlePerPageChange = e => {
    dispatch(setItemsPerPage(Number(e.target.value)))
  }

  return (
    <div className="page-content  customers_page">
      <div className="container-fluid">
        <Breadcrumbs />
        <Row>
          <Col xl={12}>
            <Card>
              <DataExportDropdown
                cardTitle={t("Loyalty Lists")}
                isXLSX={false}
                isAddBtn={loyaltyLoading ? false : usersPermissions.edit}
                addBtnText={t("Add Loyalty Points")}
                onAddBtnClick={() => navigate("/customers/loyalty/add")}
                isExportData={loyaltyLoading ? false : authUser?.allowExports}
                onDownloadCSV={exportToCSV}
                onDownloadExcel={handleExcelDownload}
                isCustomPage={true}
                perPageOptions={perPageOptions}
                itemsPerPage={itemsPerPage}
                handlePerPageChange={handlePerPageChange}
              />
              <CardBody>
                <Filters
                  filters={filters}
                  searchTerm={searchTerm}
                  handleSearchChange={handleSearchChange}
                  handleFilterChange={handleFilterChange}
                  handleSearch={handleSearch}
                  handleReset={handleReset}
                  onReset={handleReset}
                  selectedFilters={selectedFilters}
                  isRangeDate={true}
                  dateRange={dateRange}
                  setDateRange={setDateRange}
                  flatpickrRef={flatpickrRef}
                  searchBy={t("Name, Phone Number")}
                  isSecondSearch={true}
                  searchTerm2={searchTerm2}
                  handleSearchChange2={handleSearchChange2}
                  searchBy2={t("Order No.")}
                  colSize={4}
                />

                <div className="table-responsive">
                  {loyaltyLoading ? (
                    <TableShimmer row={7} col={9} />
                  ) : customerLoyaltyPoints.length === 0 ? (
                    <p className="text-center my-2">
                      {t("No loyalty points found")}
                    </p>
                  ) : (
                    <Table className="table mb-0 capitalize_td">
                      <thead className="table-light full_th">
                        <tr>
                          <th>{t("S. No.")}</th>
                          <th>{t("Name")}</th>
                          <th>{t("Phone Number")}</th>
                          <th>{t("Order No")}</th>
                          {/* <th>{t("Branch Name")}</th> */}
                          <th>{t("Points")}</th>
                          <th>{t("Type")}</th>
                          <th>{t("Source")}</th>
                          <th>{t("Remark")}</th>
                          <th>{t("Created At")}</th>
                          <th>{t("Expires At")}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {customerLoyaltyPoints.map(
                          (
                            {
                              _id,
                              userData,
                              type,
                              amount,
                              points,
                              provider,
                              redeemed,
                              remarks,
                              orderNo,
                              currency,
                              source,
                              createdAt,
                              expiresAt,
                              // orderData,
                            },
                            index
                          ) => (
                            <tr key={_id}>
                              <td scope="row">
                                {" "}
                                {(currentPage - 1) * itemsPerPage + index + 1}
                              </td>
                              <td>{userData?.name || "-"}</td>
                              <td>{userData?.phoneNumber || "-"}</td>
                              <td>{orderNo || "-"}</td>
                              {/* <td>
                                {language === "sa"
                                  ? orderData?.branchNameAr || "-"
                                  : orderData?.branchName || "-"}
                              </td> */}
                              <td>{points}</td>
                              <td
                                className={`
                                ${type === "collect" ? "text-success" : ""}
                                ${type === "redeem" ? "text-danger" : ""}
                                ${type === "cancel" ? "text-warning" : ""}
                                `}
                              >
                                {type}
                              </td>
                              <td>{source}</td>
                              <td>{remarks}</td>
                              <td>{formatDateTime(createdAt)}</td>
                              <td>{formatDateTime(expiresAt)}</td>
                            </tr>
                          )
                        )}
                      </tbody>
                    </Table>
                  )}
                </div>
                {!loyaltyLoading && (
                  <div className="mt-3">
                    <Paginations
                      data={customerLoyaltyPoints}
                      itemsPerPage={itemsPerPage}
                      onPageChange={onPageChange}
                      currentPage={currentPage}
                      totalPages={totalPages}
                      totalCount={totalCount}
                    />
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  )
}

export default CustomerLoyalty
